import { connect } from "react-redux";
import * as financingActions from "./actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)

function mapStateToProps(state) {
  return {
    financings: state.financing.financings,
    loansForPayout: state.financing.financingsIssued,
    financingsReady: state.financing.financingsReady,
    accountInfo: state.financing.accountInfo,
    investmentInfo: state.financing.investmentInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFinancings: () => {
      dispatch(financingActions.get_financings());
    },

    getFinancingBookingAccountInfo: (accountId) => {
      dispatch(financingActions.get_financing_booking_account_info(accountId));
    },

    getInvestmentInfo: (creditId) => {
      dispatch(financingActions.get_investment_info(creditId));
    },

    realiseFinancing: (financingId) => {
      dispatch(financingActions.realise_financing(financingId));
    },

    changeFinancingListPage: (page) => {
      dispatch(financingActions.change_financing_list_page(page, "InProgress"));
    },

    changeFinancingListFilter: (type, key, value) => {
      dispatch(
        financingActions.change_financing_list_filter(key, value, "InProgress"),
      );
    },

    changeFinancingIssuedListPage: (page) => {
      dispatch(financingActions.change_financing_list_page(page, "Issued"));
    },

    changeFinancingIssuedListFilter: (type, key, value) => {
      dispatch(
        financingActions.change_financing_list_filter(key, value, "Issued"),
      );
    },

    changeFinancingReadyBeRealisedListPage: (page) => {
      dispatch(financingActions.change_financing_list_page(page, "Ready"));
    },

    changeFinancingReadyBeRealisedListFilter: (type, key, value) => {
      dispatch(
        financingActions.change_financing_list_filter(key, value, "Ready"),
      );
    },

    openFinancing: (financingId, shouldPublish) => {
      dispatch(financingActions.open_financing(financingId, shouldPublish));
    },

    closeFinancing: (financingId, shouldUnpublish) => {
      dispatch(financingActions.close_financing(financingId, shouldUnpublish));
    },

    publishFinancing: (financingId) => {
      dispatch(financingActions.publish_financing(financingId));
    },

    unPublishFinancing: (financingId) => {
      dispatch(financingActions.unpublish_financing(financingId));
    },

    cancelFinancing: (financingId) => {
      dispatch(financingActions.cancel_financing(financingId));
    },

    cancelLoan: (loanId) => {
      dispatch(financingActions.cancel_loan(loanId));
    },

    getFinancingPayoutInfo: (financingId) => {
      dispatch(financingActions.get_financing_payout_info(financingId));
    },

    registerPayout: (financingId) => {
      dispatch(financingActions.register_financing_payout(financingId));
    },

    registerPayouts: (financingIds) => {
      dispatch(financingActions.register_financing_payouts(financingIds));
    },

    getLoansForPayout: () => {
      dispatch(financingActions.get_loans_for_payout());
    },
  };
}

export const financingConnector = connect(mapStateToProps, mapDispatchToProps);
